module.exports = __webpack_public_path__ + "img/landing-laptop.e7947a65.webp";